import React from 'react'

import BaseTemplate from 'components/templates/BaseTemplate'
import PromotionBanner from 'components/organisms/PromotionBanner/PromotionBanner'
import StickyBasicContent from 'components/organisms/StickyBasicContent'

import config from 'config'

import PintariaDescription from './PintariaDescription'
import PintariaWhy from './PintariaWhy'
import PintariaTestimonies from './PintariaTestimonies'
import PintariaFAQ from './PintariaFAQ'
import PintariaContact from './PintariaContact'
import PintariaMajor from './PintariaMajor/PintariaMajor'

const { assets_url: assetsUrl } = config
const pintariaAssetsPath = `${assetsUrl}/assets/img/pintaria`

const PintariaLanding = () => {
  const banner = {
    bannerDesktop: `${pintariaAssetsPath}/banner/header@2x.jpg`,
    bannerDesktopAlt: 'pintaria',
    bannerMobile: `${pintariaAssetsPath}/banner/header-sp.jpg`,
    bannerMobileAlt: 'pintaria',
    leadsRequired: false,
    url: 'https://pintaria.com/kuliah/online/kelas-karyawan/quipper',
    noContainer: true,
  }
  return (
    <BaseTemplate
      stickyBottomContent={
        <StickyBasicContent
          logo={`${pintariaAssetsPath}/description/pintaria-logo.png`}
          title="Pintaria"
          href="https://pintaria.com/kuliah/online/kelas-karyawan/quipper"
          buttonVariant="orange"
          buttonText="Daftar Sekarang"
          noTitle
        />
      }
      useStickyBottom
    >
      <div className="pintaria-landing">
        <PromotionBanner promotion={banner} />
        <PintariaDescription />
        <PintariaWhy />
        <PintariaMajor />
        <PintariaTestimonies />
        <PintariaFAQ />
        <PintariaContact />
      </div>
    </BaseTemplate>
  )
}

export default PintariaLanding
